import { render, staticRenderFns } from "./Broadcasts.vue?vue&type=template&id=36778afc&"
import script from "./Broadcasts.vue?vue&type=script&lang=js&"
export * from "./Broadcasts.vue?vue&type=script&lang=js&"
import style0 from "./Broadcasts.vue?vue&type=style&index=0&id=36778afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports